module.exports = __webpack_public_path__ + "img/stock3.9b5c788b.png";